export default __webpack_public_path__ + "static/media/thin-calendar-black.b3f531b3.svg";